import debounce from "lodash/debounce";
import resolve from "ng";

export const touch =
  /iPad|iPhone|iPod|Andriod|Mobile|Touch/gi.test(navigator.userAgent) ||
  "ontouchstart" in window ||
  window.navigator.maxTouchPoints > 0 ||
  window.navigator.msMaxTouchPoints > 0 ||
  (window.DocumentTouch && document instanceof DocumentTouch);

export class PageConfig {
  constructor() {
    this.showHeader = true;
    this.showBreadcrumbs = true;
    this.showFooter = true;
    this.touch = touch;
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.listeners = [];
  }

  init($rootScope) {
    // $transitions.onStart({ to: '*', from: '*' }, this.onBeforeUnload.bind(this));
    // $transitions.onSuccess({ to: '*', from: '*' }, this.goTop.bind(this));
    this.$on("$stateChangeSuccess", this.goTop.bind(this));
    this.$on("$stateChangeStart", this.onBeforeUnload.bind(this));
    this.$on("$locationChangeStart", this.onBeforeUnload.bind(this));
    window.addEventListener("resize", debounce(this.resized.bind(this), 300));
    window.addEventListener(
      "beforeunload",
      this.onBeforeWindowUnload.bind(this)
    );
    window.onunload = () => this.$broadcast("onUnload");
  }
  resized() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.$emit("pageResized", this);
    this.$apply();
  }

  onBeforeWindowUnload(event) {
    let confirmation = { event, window: true };
    let broadcasted = this.$broadcast("onBeforeUnload", confirmation);
    if (confirmation.message && confirmation.message.length) {
      event.preventDefault();
      return (event.returnValue = confirmation.message);
    }
    delete event.returnValue;
    return;
  }

  onBeforeUnload(event, to, from) {
    let confirmation = { event, to, from };
    this.$broadcast("onBeforeUnload", confirmation);
    if (
      confirmation.message &&
      confirmation.message.length &&
      !window.confirm(confirmation.message)
    ) {
      event.preventDefault();
    }
  }

  fullScreen(enabled) {
    this.showHeader = this.showFooter = this.showBreadcrumbs = !enabled;
  }

  goTop() {
    // Close navbar menu (if open)
    document.body.focus();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    //console.warn("goTop", ...arguments);
  }

  isMobile() {
    return this.width < 768;
  }

  is(size) {
    if (size === "xs" && this.width < 544) return true;
    if (size === "gt-xs" && this.width >= 544) return true;
    if (size === "lt-sm" && this.width < 544) return true;
    if (size === "sm" && this.width >= 544 && this.width < 768) return true;
    if (size === "gt-sm" && this.width >= 768) return true;
    if (size === "lt-md" && this.width < 768) return true;
    if (size === "md" && this.width >= 768 && this.width < 992) return true;
    if (size === "gt-md" && this.width >= 992) return true;
    if (size === "lt-lg" && this.width < 992) return true;
    if (size === "lg" && this.width >= 992 && this.width < 1200) return true;
    if (size === "gt-lg" && this.width >= 1200) return true;
    if (size === "lt-xl" && this.width < 1200) return true;
    if (size === "xl" && this.width >= 1200) return true;
    return false;
  }

  $apply() {
    const $rootScope = resolve("$rootScope");
    $rootScope.$apply(...arguments);
  }

  $emit() {
    const $rootScope = resolve("$rootScope");
    $rootScope.$emit.apply($rootScope, arguments);
  }

  $on() {
    const $rootScope = resolve("$rootScope");
    return this.listeners.push($rootScope.$on.apply($rootScope, arguments));
  }

  $broadcast() {
    const $rootScope = resolve("$rootScope");
    return this.$broadcast.apply($rootScope, arguments);
  }

  dispose() {
    this.listeners.forEach((un) => un());
  }
}

export default new PageConfig();
